export default {
  image: 'Imagem',
  pdf: 'PDF',
  video: 'Vídeo',
}
